module.exports = __webpack_public_path__ + "static/media/USDC_USDT_Mdex.1e2d0da9.png";